<script>
import PDFWalker from '../../PDFWalker.svelte';
import { getText } from '../../../../share/utils';
</script>

<div class="page-tourism-beratung marginbox">
	<div class="flex structure">
		<div class="flex row structure-1">
			<div class="flex element">
				<PDFWalker pdfName="FLU_Fotobuch.pdf" width="1000" height="1000"/>
			</div>
			
			<div class="flex element">
				<div class="text">
					<h2 class="caption">{getText("11.06.01_h2")}</h2>
					<p class="caption">{getText("11.06.02_caption")}</p>
					<p class="caption blue">Project Lead: <a href="//www.zebra.de" target="_blank">Zebra</a></p>
				</div>
			</div>
		</div>
	</div>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";
	
	img {
		width: 100%;
		margin: 0;
		padding: 0;
	}
	
	.img-single {
		margin: $spacing-mobile $spacing-mobile $media-gap $spacing-mobile;
	}
	
	h2,
	h2 {
		margin-bottom: $media-gap;
	}
	
	.page-tourism-beratung {
		.flex {
			display: flex;
			box-sizing: border-box;
		}
		
		.row {
			flex-flow: row wrap;
		}
		
		.col {
			flex-flow: column wrap;
		}
		
		.element {
			min-width: 100px;
		}
		
		.commercial {
			position: relative;
			width: 100%;
			height: 100%;
		}
		
		.content {
			flex: 1 100%;
		}
		
		.structure {
			flex-flow: row wrap;
		}
		
		.structure-1 {
			width: 100%;
			padding: 0;
			position: relative;
			
			> .element {
				width: 100%;
				margin-bottom: $media-gap;
				height: fit-content;
			}
		}
		
		.text {
			margin: 0;
		}
	}

	:global(.inner .marginbox .pdfwalker.marginbox) {
		width: 100%;
		margin-left: 0;
		margin-right: 0;
	}
</style>
